import React from 'react'

import { getIn, FieldProps, Field } from 'formik'

import { AnimatedField, FormikField } from './FormikPasswordField.styled'

type FormikPasswordFieldProps = {
    name: string
    label: string
    disabled?: boolean
    placeholder?: string
    requirements?: Array<{ label: string; valid: boolean }>
}

function FormikPasswordField({
    name,
    placeholder = '',
    label,
    disabled = false,
    requirements,
}: Readonly<FormikPasswordFieldProps>) {
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                const touched = getIn(form.touched, field.name)
                const error = getIn(form.errors, field.name)

                return (
                    <AnimatedField>
                        <FormikField
                            disabled={
                                disabled ||
                                form.values.disabledFields?.includes(field.name)
                            }
                            error={!!(touched && error)}
                            helpText={touched ? error : ''}
                            id={field.name}
                            name={field.name}
                            label={label}
                            value={field.value}
                            onChange={(val: string) => {
                                const event = {
                                    target: {
                                        name,
                                        value: val,
                                    },
                                }

                                form.handleChange(event)
                            }}
                            onBlur={form.handleBlur}
                            requirements={requirements}
                            placeholder={placeholder}
                            data-testid={name}
                        />
                    </AnimatedField>
                )
            }}
        </Field>
    )
}

export default FormikPasswordField
